import bbc_logo from '../images/bbc_logo.svg';
import client_logo from '../images/client_logo.png';
import social_image from '../images/social.jpg'
import social_twitter from '../images/socialtwitter.jpg'

let liveDomain = "https://www.bbc.com"
let liveUrlBase = liveDomain+"/travel/bespoke/50-reasons-to-love-the-world" 
let liveUrl = liveUrlBase+"/" 

let GlobalData = {
    VideoCDNPath:"https://static2.bbcverticals.com/travel/bespoke/50-reasons-to-love-the-world/assets/video/",
    AnimationAssetCDNPath:"https://static2.bbcverticals.com/travel/bespoke/50-reasons-to-love-the-world/assets/animation/",
    pageTitle:"50 Reasons to Love the World – 2021",
    pageDescription:"BBC Travel celebrates well-known voices as well as unsung heroes in local communities around the globe.",
    keywords:"new,hope,travel,world,stories",
    liveURL:liveUrl,
    tracking:{
        gaCategory:"50reasons"
    },
    advertising:{
        networkID:"4817",
        adUnit:"bbccom.live.site.travel"
    },
    metaData:{
        title:"50 Reasons to Love the World",
        facebookDescription:"BBC Travel celebrates well-known voices as well as unsung heroes in local communities around the globe.",
        facebookSocialImage:liveDomain+social_image,
        twitterDescription:"BBC Travel celebrates well-known voices as well as unsung heroes in local communities around the globe.",
        twitterSocialImage:liveDomain+social_twitter,
        urlPath:liveUrl,
        imageAlt:"50 Reasons to love the world",
    },
    header:{
        bbc:{
            logoPath: bbc_logo,
            bbcURL: "http://www.bbc.co.uk/storyworks/",
            alt: "BBC Storyworks"
        },
        client:{
            logoPath: client_logo,
            clientURL: "https://www.delta.com/us/en/about-delta/overview",
            alt: "Client logo",
            copy: "In Association with"
        }
    },
    footer:{
        copyright:{
            copy:"Copyright © 2021 BBC. The BBC is not responsible for the content of external sites.",
            readMore:" Read more",
            URL:"http://www.bbc.co.uk/help/web/links/"
        },
        cookies:{
            cookieCopy:"Cookies",
            cookieURL:"https://www.bbc.co.uk/usingthebbc/cookies/",
            adChoices:"Ad Choices/ Do Not Sell My Info",
            adChoicesURL: "https://www.bbc.com/usingthebbc/cookies/how-does-the-bbc-use-cookies-for-advertising/"
        }

    }
}

export default GlobalData;